import Vue from 'vue';
import VueRouter from 'vue-router';
// eslint-disable-next-line import/extensions
import store from '../store/index.js';
// import HomeView from '../views/HomeView.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'landing',
    component: () => import(/* webpackChunkName: "about" */ '../views/LandingView.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      // if (user.role === 'Administrator') next('/admin');
      // else if (user.role === 'Regular') next('/map');
      // else next();
      if (user.email) next('/survey');
      else next();
    },
  },
  {
    path: '/survey',
    name: 'survey',
    component: () => import(/* webpackChunkName: "about" */ '../views/SurveyView.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      // if (user.role === 'Administrator') next('/admin');
      // else if (user.role === 'Regular') next('/map');
      // else next();
      if (user.email) next();
      else next('/');
    },
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import(/* webpackChunkName: "about" */ '../views/AdminView.vue'),
    beforeEnter: (to, from, next) => {
      const user = store.getters.getLoggedInUser
        ? store.getters.getLoggedInUser
        : {};

      // if (user.role === 'Administrator') next('/admin');
      // else if (user.role === 'Regular') next('/map');
      // else next();
      console.log(user);
      if (user.admin) next();
      else next('/');
    },
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
